import { render, staticRenderFns } from "./AnnouncementCard.vue?vue&type=template&id=095f419e&scoped=true"
import script from "./AnnouncementCard.vue?vue&type=script&lang=js"
export * from "./AnnouncementCard.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementCard.vue?vue&type=style&index=0&id=095f419e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f419e",
  null
  
)

export default component.exports